import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { DeduccionesIIGG } from '../models/deducciones-IIGG';

const baseUrl = environment.hostService + '/DeduccionesIIGG';

@Injectable({
  providedIn: 'root'
})
export class DeduccionesIiggService {
    
  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  getByPersonal(id: number, agrupar: boolean): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetByPersonalId/' + id + '/' + agrupar })
  }

  getHistoryByClase(idPersonal: number, codigosNomina: number): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetHistoryByCodigoNomina/' + idPersonal + '/' + codigosNomina });
  }

  save(datos: DeduccionesIIGG, cortarRegistro: boolean): Observable<any>
  {
    return this._http.post<any>({ url: baseUrl + '/Save/' + cortarRegistro, body: datos });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });
  }
}

